/* eslint-disable no-param-reassign */
import { BaseComponent } from "utils/base-component"
import SwellTooltip from "./swell-tooltip"
import "./index.scss"

const TOOLTIP_ROW_RE = /^(swell|wave-energy[1-4]?|wave-graph)$/

type CellMeta = {
  key: string
  index: number
}

declare global {
  interface Window {
    initFCTableCell?: (day: any, td: HTMLTableCellElement, meta: CellMeta) => boolean | void
  }
}

window.initFCTableCell = (day, td, { key, index }) => {
  if (!day.swellTooltips) day.swellTooltips = []
  if (key === "wave-graph") {
    day.swellTooltips[index] = JSON.parse(td.dataset.swellTooltip)
  }

  if (TOOLTIP_ROW_RE.test(key)) {
    const tooltip = new SwellTooltip(td, () => day.swellTooltips[index])
    tooltip.init()
  }

  return false
}

export class SurfForecastTable extends BaseComponent {
  static cssClass = "surf-forecast-table"

  init() {
    const tabs = this.elements("tab")
    tabs.forEach((tab) =>
      tab.element.addEventListener("click", (e) => {
        e.preventDefault()
        tabs.forEach((t) => {
          t.toggleModifier("active", t.element.dataset.tab === tab.element.dataset.tab)
        })
      }),
    )
  }
}
